// extracted by mini-css-extract-plugin
export default {"main":"style_main__JGiEn","container":"style_container__6F3Vh","jobs":"style_jobs__CaG54","button":"style_button__4jycT"};